<template>
  <div class="whitespace-nowrap">
    <!-- Оптимизация: disabled tooltip удалён (строка 3), активный заменён на v-b-tooltip директиву (строка 7) -->
    <div v-if="!item.activity || !item.activity.Email || !item.activity.Email.date" class="notf-icon">
      <img :src="iconEmailGrey"/>
    </div>
    <div v-else @click="goToEmail(item)" class="notf-icon">
      <img
          :src="iconEmailBlue"
          v-b-tooltip.hover.leftbottom.html="{
            title: `Unread ${item.activity.Email.smsId ? 'SMS' : 'email'} message at:<br/><strong>${item.activity.Email.date}</strong>`,
            customClass: 'ps-tooltip ps-tooltip-table-custom'
          }"
      />
    </div>

    <!-- Оптимизация: disabled tooltip удалён (строка 27), активный заменён на v-b-tooltip директиву (строка 29) -->
    <div v-if="item?.activity?.External?.notice &&  item.activity.External.notice  != ''"
         class="notf-icon">
      <img
          :src="iconExternalBlue"
          v-b-tooltip.hover.leftbottom="{
            title: item.activity.External.notice,
            customClass: 'ps-tooltip ps-tooltip-table-custom'
          }"
      />
    </div>
    <div v-else class="notf-icon">
      <img :src="iconExternalGrey"/>
    </div>

    <!-- Оптимизация: disabled tooltip удалён (строка 51), два активных заменены на одну v-b-tooltip директиву (строка 55) -->
    <div
        v-if="item.activity && item.activity.Assignment && item.activity.Assignment.type"
        class="notf-icon"
    >
      <img
          :src="iconAssignBlue"
          v-b-tooltip.hover.leftbottom.html="{
            title: (item.activity.Assignment.type === 'Task'
              ? `Task Assigned From:<br/><strong>${item.activity.Assignment.from}</strong>`
              : `File Assigned From:<br/><strong>${item.activity.Assignment.from}</strong>`),
            customClass: 'ps-tooltip ps-tooltip-table-custom'
          }"
      />
    </div>
    <div v-else class="notf-icon">
      <img :src="iconAssignGrey"/>
    </div>

    <!-- Оптимизация: disabled tooltip удалён (строка 73), активный заменён на v-b-tooltip директиву (строка 77) -->
    <div
        v-if="item.activity && item.activity.Message && item.activity.Message.date"
        class="notf-icon"
    >
      <img
          :src="iconMessageBlue"
          v-b-tooltip.hover.leftbottom.html="{
            title: `Message From:<br/><strong>${item.activity.Message.from}</strong>`,
            customClass: 'ps-tooltip ps-tooltip-table-custom'
          }"
      />
    </div>
    <div v-else class="notf-icon">
      <img :src="iconMessageGrey"/>
    </div>
  </div>
</template>

<script>
import iconEmailGrey from '../assets/img/bx-envelope-gray.svg'
import iconEmailBlue from '../assets/img/bx-envelope-blue.svg'
import iconExternalGrey from '../assets/img/bx-link-external-gray.svg'
import iconExternalBlue from '../assets/img/bx-link-external-blue.svg'
import iconAssignGrey from '../assets/img/bx-user-gray.svg'
import iconAssignBlue from '../assets/img/bx-user-blue.svg'
import iconMessageGrey from '../assets/img/bx-message-rounded-gray.svg'
import iconMessageBlue from '../assets/img/bx-message-rounded-blue.svg'
import iconMessage from '../assets/img/bx-message-rounded.svg'
import _ from 'lodash'

export default {
  props: {
    item: {
      type: Object,
      default: {
        card_id: '',
        activity: {
          Email: {
            date: '',
            id: 0,
            from: '',
            activity_id: 0,
          },
          Assignment: {
            from: '',
            type: ''
          },
          Message: {
            from: '',
            date: ''
          },
          External: {
            from: '',
            date: '',
            notice: '',
          },
        },
      }
    },
    // Unique String ID
    // must be unique row and tab
    name: {
      type: String,
    }
  },
  data () {
    return {
      iconEmailGrey,
      iconEmailBlue,
      iconExternalGrey,
      iconExternalBlue,
      iconAssignGrey,
      iconAssignBlue,
      iconMessageGrey,
      iconMessage,
      iconMessageBlue
    }
  },
  computed:{
    CMS () {
      let cms = this.item?.activity?.External?.from
      if (_.toLower(cms) === 'iag' || _.toLower(cms) === 'orm') {
        return 'ORM'
      } else if (_.toLower(cms) === 'claimlinq') {
        return 'ClaimLinq'
      } else if (_.toLower(cms) === 'estimage' ||  _.toLower(cms) === 'estimage online' ||  _.toLower(cms) === 'estimageonline'  ) {
        return 'Estimage'
      }
      return _.toUpper(cms)

    }
  },
  methods: {
    goToEmail (item) {
      this.$router.push(
          { name: 'CardsEdit', params: { action: 'goToEmail', card_id: item.card_id, activityId: item.activity.activityId } }
      )
    },

  }
}
</script>

<style>
.ps-tooltip-table-custom{
  top: 10px !important;
  left: 5px !important;
}
</style>
